import { useState } from "react";
import {
  Modal,
  Typography,
  Space,
  Button,
  Input,
  Alert,
  Card,
  message,
  Divider,
} from "antd";
import {
  KeyOutlined,
  CopyOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

const PasswordResetModal = ({ visible, onClose, userData, resetLink }) => {
  const [copying, setCopying] = useState(false);

  const handleCopyLink = async () => {
    try {
      setCopying(true);
      await navigator.clipboard.writeText(resetLink || "");
      message.success("Setup link copied");
    } catch {
      message.error("Copy failed");
    } finally {
      setCopying(false);
    }
  };

  if (!userData) return null;

  const isActive = userData.isActive;

  return (
    <Modal
      title={
        <Space>
          <KeyOutlined style={{ color: "#fa8c16" }} />
          <Title level={4} style={{ margin: 0 }}>
            {isActive ? "User Access Info" : "User Setup Link"}
          </Title>
        </Space>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose} size="large">
          Close
        </Button>,
      ]}
      width={600}
      destroyOnClose
    >
      <div style={{ padding: "16px 0" }}>
        {/* STATUS */}
        {isActive ? (
          <Alert
            message="User already onboarded"
            description="This user has already set their password and can log in."
            type="success"
            showIcon
            style={{ marginBottom: 24 }}
          />
        ) : (
          <Alert
            message="Setup link generated"
            description="Share this link securely with the user to complete account setup."
            type="info"
            showIcon
            style={{ marginBottom: 24 }}
          />
        )}

        {/* USER INFO */}
        <Card
          title={
            <Space>
              <UserOutlined />
              <span>User Info</span>
            </Space>
          }
          style={{ marginBottom: 24 }}
          size="small"
        >
          <Text strong>{userData.name}</Text>
          <br />
          <Text>{userData.email}</Text>
          <br />
          <Text type="secondary">{userData.role}</Text>
        </Card>

        {/* LINK */}
        {!isActive && (
          <>
            <Text strong>Setup Link</Text>
            <Input.Group compact style={{ marginTop: 8 }}>
              <Input
                value={resetLink}
                readOnly
                style={{ width: "calc(100% - 120px)" }}
              />
              <Button
                type="primary"
                icon={<CopyOutlined />}
                onClick={handleCopyLink}
                loading={copying}
                style={{ width: "120px" }}
              >
                Copy
              </Button>
            </Input.Group>

            <div style={{ marginTop: 12 }}>
              <ClockCircleOutlined />{" "}
              <Text type="secondary">Expires as per server policy</Text>
            </div>
          </>
        )}

        <Divider />

        <Alert
          message="Security"
          description="Do not share this link publicly. It grants account access setup."
          type="warning"
          showIcon
        />
      </div>
    </Modal>
  );
};

export default PasswordResetModal;
